import { domainIds } from '../../StaticData/Domains';

const DefaultValues = {
  domains: [domainIds.tmn_tag]
};

export default DefaultValues;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/AdTag/StaticData/DefaultValues.tsx